import { isNil } from 'lodash'
import { useRef } from 'react'
import { connect } from 'react-redux'
import { expandLeftToolbar, collapseLeftToolbar } from '../../../action/left-toolbar-state-actions'
import { trackPolylineOptions } from '../../../lib/trackColor'
import { contentVisibilityKey } from '../../../action/hidden-content-ids-actions'
import { parseRouteGeoJson } from '../../../lib/routeDocument'

// Draws saved Route Builder routes (measurementTypeId 2, from iOS, Android or web).
// Clicking one opens it in the Route Builder's ROUTE DETAILS panel. Mirrors
// RenderTracks: a route object without mapObj is (re)drawn, so a save that swaps in
// a fresh object from the server redraws it with the new geometry and style.
const RenderRoutes = (props) => {
  const { routes, mapReference, expandLeftToolbar, collapseLeftToolbar, hiddenContentTypes, hiddenContentIds, editingRouteId } = props
  const drawnRef = useRef(new Map())
  if (mapReference === null || typeof google === 'undefined') return null

  const hideRoutes = hiddenContentTypes.includes('routes')
  // The route open in the builder is drawn by the builder itself (it changes live).
  const isHidden = route => hideRoutes || route.id === editingRouteId ||
    hiddenContentIds.includes(contentVisibilityKey('route', route.id))

  const removeDrawn = (id) => {
    const drawn = drawnRef.current.get(id)
    if (drawn) { try { drawn.setMap(null) } catch (e) { /* already gone */ } drawnRef.current.delete(id) }
  }

  // Drop lines for routes that are hidden or no longer in the store (deleted).
  const liveIds = new Set(routes.map(r => r.id))
  Array.from(drawnRef.current.keys()).forEach(id => { if (!liveIds.has(id)) removeDrawn(id) })
  routes.forEach(route => {
    if (!isHidden(route)) return
    removeDrawn(route.id)
    route.mapObj = null
  })

  routes.filter(route => isNil(route.mapObj) && !isHidden(route) && route.geoJson).forEach(route => {
    route.measureType = 'route'
    const doc = parseRouteGeoJson(route.geoJson)
    if (!doc || doc.coords.length < 2) return
    removeDrawn(route.id)
    const line = new google.maps.Polyline({
      name: route.name,
      map: mapReference,
      path: doc.coords.map(c => new google.maps.LatLng(c[1], c[0])),
      zIndex: 10,
      ...trackPolylineOptions(doc.line.color, doc.line.style, doc.line.width),
      options: { draggable: false, clickable: true, cursor: 'pointer' },
      metadata: { id: route.id, type: 'routes' }
    })
    route.mapObj = function () { return line }
    drawnRef.current.set(route.id, line)
    line.addListener('click', () => {
      collapseLeftToolbar()
      expandLeftToolbar({ dialog: 'edit', editable: route })
    })
  })
  return null
}

const mapStateToProps = state => {
  const editable = state.leftToolbarState && state.leftToolbarState.editable
  return {
    mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
    routes: state.routes || [],
    hiddenContentTypes: state.hiddenContentTypes,
    hiddenContentIds: state.hiddenContentIds,
    editingRouteId: editable && editable.measureType === 'route' ? editable.id : null
  }
}

const mapDispatchToProps = dispatch => ({
  expandLeftToolbar: props => dispatch(expandLeftToolbar(props)),
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar())
})

export default connect(mapStateToProps, mapDispatchToProps)(RenderRoutes)
